import React from 'react';
import favImg from '../images/fav.png';
import nofavImg from '../images/nofav.png';
import './ToolBar.css';

class ToolBar extends React.Component {
    state = { fav: false }
    favoriteSearch() {
        this.setState({ fav: !this.state.fav }, _ => {
            this.props.click(this.state.fav);
        });
    }
    render() {
        return (
            <div className="star-fav" onClick={_ => this.favoriteSearch()}> 
                    <img alt="favoriteLogo" style={{ width: "50px" }} src={this.state.fav ? favImg : nofavImg} />
            </div>
        )
    }
}

export default ToolBar;